package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val PeriodeLabelStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .styleModifier {
                property("transition", "opacity 200ms ease")
            }
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}


val CheckboxLabelStyle = CssStyle {
    base {
        Modifier.fontSize(12.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(14.px)
    }
}

val DropdownSelectStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
            .height(40.px)
            .borderRadius(5.px)
            .padding(
                left = 10.px,
                right = 20.px
            )
            .fontSize(16.px)
            .border(0.px)
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("box-sizing", "border-box")
                property("outline", "none")
                property(
                    "transition",
                    "border-color 200ms ease, opacity 200ms ease"
                )
            }
    }
}